import React, { Suspense } from 'react';
import ReactDOM from 'react-dom/client';

import App from './App.tsx';
import { RootErrorBoundary } from './components/root-error-boundary';
import { Toaster } from './components/ui/toaster';
import { UpdateHandler } from './components/update-handler';
import { ApolloProvider } from './providers/apollo-provider';
import { AppConfigProvider } from './providers/app-config-provider';
import { AppSettingsProvider } from './providers/app-settings-provider';
import { ChakraProviderWithColorMode } from './providers/chakra-provider';
import { PageLayoutProvider } from './providers/page-layout-provider';
import { SidebarProvider } from './providers/sidebar-provider';
import { UserProvider } from './providers/user-provider';
import { getRegistration } from './utils/sw-registration';
import '@milkdown/crepe/theme/common/style.css';
import './styles/crepe.css';
import './index.css';

if (import.meta.env.PROD && typeof window !== 'undefined') {
  window.addEventListener('load', () => {
    void getRegistration();
  });
}

function AppSettingsFallback() {
  return (
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '100vh',
        fontFamily: 'system-ui, sans-serif',
      }}
    >
      Loading…
    </div>
  );
}

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <AppConfigProvider>
      <ApolloProvider>
        <RootErrorBoundary>
          <Suspense fallback={<AppSettingsFallback />}>
            <AppSettingsProvider>
              <ChakraProviderWithColorMode>
                <UserProvider>
                  <SidebarProvider>
                    <PageLayoutProvider>
                      <UpdateHandler />
                      <App />
                      <Toaster />
                    </PageLayoutProvider>
                  </SidebarProvider>
                </UserProvider>
              </ChakraProviderWithColorMode>
            </AppSettingsProvider>
          </Suspense>
        </RootErrorBoundary>
      </ApolloProvider>
    </AppConfigProvider>
  </React.StrictMode>,
);
